import { ref, onMounted, onUnmounted } from 'vue'
import {
  COOKIE_CATEGORIES,
  hasCookieConsent,
  onCookieConsentChange,
  openCookieSettings,
} from '../lib/cookieConsent.js'

export function useCookieConsent() {
  const externalAllowed = ref(hasCookieConsent(COOKIE_CATEGORIES.EXTERNAL))
  const analyticsAllowed = ref(hasCookieConsent(COOKIE_CATEGORIES.ANALYTICS))

  let unsubscribe = null

  const syncConsentState = () => {
    externalAllowed.value = hasCookieConsent(COOKIE_CATEGORIES.EXTERNAL)
    analyticsAllowed.value = hasCookieConsent(COOKIE_CATEGORIES.ANALYTICS)
  }

  onMounted(() => {
    syncConsentState()
    unsubscribe = onCookieConsentChange(syncConsentState)
  })

  onUnmounted(() => {
    if (unsubscribe) unsubscribe()
  })

  return {
    COOKIE_CATEGORIES,
    externalAllowed,
    analyticsAllowed,
    hasCookieConsent,
    openCookieSettings,
  }
}
